<template>
	  <div id="app">
	    	<router-view/>
	  </div>
</template>

<script>
	export default {
			name: 'app',
			data(){
				return{

				}
			},
			
			mounted(){
			},
			methods:{
				
			}
	}
</script>

<style>
#app{
font-family: "Montserrat-Medium";
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue